/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CloudRegion } from '../models/CloudRegion';
import { Pagination } from '../models/Pagination';

export class ListInventorySourceRegionsResponse {
  'regions': Array<CloudRegion>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "regions",
      "baseName": "regions",
      "type": "Array<CloudRegion>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListInventorySourceRegionsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

